import { AdditionalData } from '@dispatch/shared/types';
import { some } from 'lodash';

export function buildNotesFromAdditionalData(
  data: AdditionalData | undefined
): string {
  if (!data || !some(data, (value) => value !== undefined && value !== '')) {
    return '';
  }

  const notesLines: string[] = [];

  if (data.additionalComments) {
    notesLines.push(`Additional Comments: ${data.additionalComments}`);
  }

  if (data.referrersPhone) {
    notesLines.push(`Referrers Phone: ${data.referrersPhone}`);
  }

  if (data.lineOfBusiness) {
    notesLines.push(`Line of Business: ${data.lineOfBusiness}`);
  }

  if (data.exposureNumber) {
    notesLines.push(`Exposure Number: ${data.exposureNumber}`);
  }

  if (data.strategicBusinessUnit) {
    notesLines.push(`Strategic Business Unit: ${data.strategicBusinessUnit}`);
  }

  if (data.scopeOfWork) {
    notesLines.push(`Scope of Work: ${data.scopeOfWork}`);
  }

  if (data.typeOfReport) {
    notesLines.push(`Type of Report: ${data.typeOfReport}`);
  }

  if (data.budget) {
    notesLines.push(`Budget: ${data.budget}`);
  }

  if (data.fileInLitigation) {
    notesLines.push(
      `File in Litigation: ${data.fileInLitigation === 'yes' ? 'Yes' : 'No'}`
    );
  }

  if (
    data.vehicleMake ||
    data.vehicleModel ||
    data.vehicleYear ||
    data.vehicleVinOrSerial
  ) {
    notesLines.push(''); // Add an empty line before vehicle information
    notesLines.push('Vehicle Information');
  }

  if (data.vehicleMake) {
    notesLines.push(`Make: ${data.vehicleMake}`);
  }

  if (data.vehicleModel) {
    notesLines.push(`Model: ${data.vehicleModel}`);
  }

  if (data.vehicleYear) {
    notesLines.push(`Year: ${data.vehicleYear}`);
  }

  if (data.vehicleVinOrSerial) {
    notesLines.push(`Serial or VIN Number: ${data.vehicleVinOrSerial}`);
  }

  return notesLines.join('\n');
}
